import React from "react";
import { Box, Grid, Typography, Card, CardContent } from "@mui/material";
import { motion } from "framer-motion";
import ISOCert from '../../LandingPageComponents/images/ISO_Paperlive.jpeg';
import { fadeInLeft } from "../animations/motionConfigs";

export default function AwardsRecognition(props) {
    const { isSmallScreen, city } = props;
    return (
        <Box
            sx={{
                width: { xs: "90%", md: "70%" },
                mx: "auto",
                mt: 6,
                mb: isSmallScreen ? 6 : 10,
            }}
        >
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: "center",
                        justifyContent: "space-between",
                        bgcolor: "#492467",
                        color: "#fff",
                        p: 4,
                        borderRadius: "20px",
                    }}
                >
                    <Box sx={{ flex: 1, pr: { md: isSmallScreen ? 2 : 4 } }}>
                        <Typography variant={isSmallScreen ? "h5" : "h4"} fontWeight="bold" gutterBottom>
                            Awards & Recognition
                        </Typography>
                        {!isSmallScreen && <br />}
                        <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                            Recognised for Excellence, Powered by Impact
                        </Typography>
                        {!isSmallScreen && <br />}
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            From industry accolades to real learner success stories, every
                            award we receive reflects our mission: To deliver DevOps training {city && `in ${city} `}
                            that truly makes a difference.
                        </Typography>
                        {!isSmallScreen && <br />}
                        <Typography variant="body1">
                            We're proud to be recognised for the impact we create, both in
                            education and in careers.
                        </Typography>
                    </Box>

                    <motion.div
                        initial={{ scale: 0.9 }}
                        whileInView={{ scale: 1 }}
                        transition={{ duration: 0.6 }}
                        style={{ flex: 1, display: "flex", justifyContent: "center" }}
                    >
                        <Box
                            component="img"
                            src={ISOCert}
                            alt="Certificate"
                            sx={{
                                width: { xs: "80%", md: "50%" },
                                borderRadius: "10px",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                                mt: { xs: 3, md: 0 },
                            }}
                        />
                    </motion.div>
                </Box>
            </motion.div>

            <Box sx={{ mt: 8 }}>
                <Typography variant={isSmallScreen ? "h5" : "h4"} fontWeight="bold" gutterBottom>
                    Industry Trends
                </Typography>

                <Grid container spacing={isSmallScreen ? 1 : 3} mt={ isSmallScreen ? 0 : 2}>
                    <Grid item xs={12} md={4}>
                        <motion.div
                            whileHover={{ y: -6 }}
                            transition={{ duration: 0.3 }}
                            {...fadeInLeft}
                        >
                            <Card
                                variant="outlined"
                                sx={{ borderRadius: "15px", height: "250px" }}
                            >
                                <CardContent>
                                    <img alt="Linkedin" loading="lazy" src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/500px-LinkedIn_logo_initials.png" width={50} />
                                    <div style={{ fontWeight: "600" }} >
                                        11,000+ DevOps Architect Jobs in the U.S. Alone!
                                    </div>
                                    <Typography variant="body2" mt={1}>
                                        The demand is real and it's growing fast. Now’s the perfect time to skill up and claim your spot in one of tech’s most rewarding roles.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </motion.div>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <motion.div
                            whileHover={{ y: -6 }}
                            transition={{ duration: 0.3 }}
                            {...fadeInLeft}
                        >
                            <Card
                                variant="outlined"
                                sx={{ borderRadius: "15px", height: "250px" }}
                            >
                                <CardContent>
                                    <img alt="Payscale" loading="lazy" src="https://upload.wikimedia.org/wikipedia/commons/c/c6/PayScale_logo.png" width={150} />

                                    <div style={{ fontWeight: "600" }} >
                                        Average Salary: $122,768/Year
                                    </div>
                                    <Typography variant="body2" mt={1}>
                                        Solutions Architects with DevOps skills earn an average of $122,768 annually in the U.S., and that number keeps rising with demand.
                                        Invest in the right skills, and watch your career (and income) grow.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </motion.div>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <motion.div
                            whileHover={{ y: -6 }}
                            transition={{ duration: 0.3 }}
                            {...fadeInLeft}
                        >
                            <Card
                                variant="outlined"
                                sx={{ borderRadius: "15px", height: "250px" }}
                            >
                                <CardContent>
                                <img alt="Codeing Game" loading="lazy" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSj3rdz6SVWY0b-g0tRaTYS7FrtQ1PqghpOS0o-tGjrW0fTvurs07mQ6sar&s=10" width={40} style={{padding: "10px 0"}} />
                                <div style={{ fontWeight: "600" }} >
                                        Developer Hiring Is Booming
                                    </div>
                                    <Typography variant="body2" mt={1}>
                                        64% of organisations are expected to hire up to 50 developers showing just how strong the demand for skilled tech talent remains.
                                        Now’s the time to upskill and become the developer companies are looking for.
                                    </Typography>
                                </CardContent>
                            </Card>
                        </motion.div>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
